import { useGetDeviceTypeConfigs } from './app-config.api';

export function useDeviceModels(deviceType: string): string[] {
  const { data: deviceTypeConfigs } = useGetDeviceTypeConfigs();
  const models = deviceTypeConfigs?.find((config) => config.type === deviceType)?.models;

  return models ?? [];
}
